/**
 * Entity KB alias mutations via dash-api REST.
 *
 * Response shape:
 *   create/delete → { aliases: string[], wikidataAliases: string[] }
 */

import {getAwpClientHeaders} from '../../session/awpRequestHeaders';

const AWP_BASE = (process.env.REACT_APP_AWP_API_BASE || process.env.REACT_APP_AWP_API_URL || '')
    .replace(/\/$/, '');

async function apiCall(method, path, body) {
    const res = await fetch(`${AWP_BASE}${path}`, {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...getAwpClientHeaders(),
        },
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });

    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        const error = new Error(err.message || err.error || `HTTP ${res.status}`);
        error.code = res.status === 409 ? 'aborted' : 'unknown';
        throw error;
    }

    return res.json();
}

function normalizeAliasResponse(data, operationName) {
    if (!data || typeof data !== 'object') {
        throw new Error(`[entityAliasMutations] ${operationName} returned an invalid response.`);
    }

    const aliases = Array.isArray(data.aliases)
        ? data.aliases
        : (Array.isArray(data.wikidataAliases) ? data.wikidataAliases : null);

    if (!aliases) {
        throw new Error(`[entityAliasMutations] ${operationName} did not return aliases.`);
    }

    return {aliases, wikidataAliases: aliases};
}

export async function createEntityAlias({entityId, alias}) {
    const result = await apiCall('POST',
        `/api/entities/${encodeURIComponent(entityId)}/aliases`,
        {alias});
    return normalizeAliasResponse(result, 'createEntityAlias');
}

export async function deleteEntityAlias({entityId, alias}) {
    const result = await apiCall('DELETE',
        `/api/entities/${encodeURIComponent(entityId)}/aliases`,
        {alias});
    return normalizeAliasResponse(result, 'deleteEntityAlias');
}
